import { render, staticRenderFns } from "./OptimizationSaving.vue?vue&type=template&id=eec3ea50&scoped=true&"
import script from "./OptimizationSaving.vue?vue&type=script&lang=js&"
export * from "./OptimizationSaving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec3ea50",
  null
  
)

export default component.exports